import React from 'react'
import { Flex, Box, Divider } from 'theme-ui'
import { PostTags, PostShare } from '@widgets/Post'

const styles = {
  flex: {
    alignItems: [`flex-start`, `flex-start`],
    justifyContent: `space-between`,
    flexDirection: [`row`, `row`],
    '& > div + div': {
      mt: [3, 0],
      flexBasis: `1/2`,
      justifyContent: `flex-end`
    }
  }
}

export const PostTagsShare = props => (
  <Box>
    <Divider />
    <Flex sx={styles.flex}>
      {/* <PostTags {...props} /> */}
      <PostShare {...props} />
    </Flex>
  </Box>
)
